export default __webpack_public_path__ + "static/media/img-0536-slovakia-full-face.db3d6996.png";